<template>
  <v-card outlined class="py-3 px-5 w-100">
    <table class="w-100">
      <tr class="no-row-border">
        <td class="no-border"></td>
        <td class="no-border"></td>
        <td v-for="(columnTitle, key) in keys" :key="key" class="table-title">
          {{ columnTitle }}
        </td>
      </tr>
      <tr v-for="(rowTitle, value, index) in values" :key="value">
        <td v-if="index === 0" class="table-title group no-border" rowspan="12">
          Composition
        </td>
        <td
          class="table-title no-col-border"
          :colspan="value === 'temp' || value === 'flow' ? 2 : undefined"
          style="width: 100px"
        >
          {{ rowTitle }}
        </td>
        <td
          v-for="(_name, key) in keys"
          :key="key"
          :class="{ empty: composition[value][key] === undefined }"
        >
          {{ composition[value][key] }}
        </td>
      </tr>
    </table>
  </v-card>
</template>

<script>
import { COMPOSITION_KEYS, COMPOSITION_VALUES } from "../../views/balance/data";

export default {
  name: "CompositionResult",

  props: {
    composition: { type: Object, required: true },
  },

  data() {
    return {
      keys: COMPOSITION_KEYS,
      values: COMPOSITION_VALUES,
    };
  },
};
</script>

<style lang="scss" scoped>
table {
  & .group {
    writing-mode: tb-rl;
    transform: rotate(-180deg);
  }
  & .empty {
    background: repeating-linear-gradient(
      135deg,
      var(--v-lightGrey-base) 0,
      var(--v-lightGrey-base) 10%,
      transparent 0,
      transparent 50%
    );
    background-size: 1em 1em;
    opacity: 1;
  }
}
</style>
